export class ScrollUtils {
  static scroll = {
    disable: () => {
      document.body.classList.add('body-no-scroll');
    },
    enable: () => {
      document.body.classList.remove('body-no-scroll');
    },
  };
}
